module.exports = __webpack_public_path__ + "img/ie_setting_00_setting2.47552a22.jpg";